import toolkit from 'toolkit/b-toolkit/b-toolkit';

const BToolkit = toolkit['b-toolkit'];

export const BPublicFile = toolkit.create('b-public-file', {
    render() {
        BToolkit.fn.render.apply(this, arguments);
    },

    destroy() {
        BToolkit.fn.destroy.apply(this, arguments);
    },
});
